export {default} from './CorruptTableLayer';



// WEBPACK FOOTER //
// ./components/qual/Table/CorruptTableLayer/index.js